import React from "react";
import { useNavigate } from "react-router-dom";
import Section from "@/components/foundation/Section";
import Button from "@/components/foundation/Button";
import FadeIn from "@/components/foundation/FadeIn";
import PartnerDashboardMock from "@/components/marketing/PartnerDashboardMock";
import { ArrowRight } from "lucide-react";

export const PartnersTeaserSection = () => {
  const navigate = useNavigate();
  return (
    <Section
      spacing="lg"
      contained
      className="relative"
      data-testid="partners-teaser-section"
    >
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-6">
          <FadeIn>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.02] px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] text-brand-emerald">
              <span className="h-1.5 w-1.5 rounded-full bg-brand-emerald shadow-[0_0_8px_rgba(0,230,118,0.7)]" />
              For Funding Partners
            </span>
          </FadeIn>

          <FadeIn delay={0.06}>
            <h2 className="mt-5 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl lg:text-6xl text-balance">
              Access verified businesses — not cold leads.
            </h2>
          </FadeIn>

          <FadeIn delay={0.12}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-text-secondary sm:text-lg">
              ZenMe is building one of the largest verified small-business
              funding ecosystems. Every merchant profile is structured around
              secure financial data, AI-powered underwriting insights, and
              complete documentation.
            </p>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Button
                variant="primary"
                size="lg"
                onClick={() => navigate("/partners")}
                rightIcon={<ArrowRight className="h-4 w-4" />}
                data-testid="partners-teaser-become-partner-btn"
              >
                Become a Funding Partner
              </Button>
              <Button
                variant="ghost"
                size="lg"
                onClick={() => navigate("/marketplace")}
                data-testid="partners-teaser-marketplace-btn"
              >
                Join the Marketplace Waitlist
              </Button>
            </div>
          </FadeIn>
        </div>

        <div className="flex items-center justify-center lg:col-span-6 lg:justify-end">
          <PartnerDashboardMock />
        </div>
      </div>
    </Section>
  );
};

export default PartnersTeaserSection;
